import * as React from "react";
import type { RouteObject } from "react-router-dom";

import { Page as NotFoundPage } from "@/pages/not-found";
import { AuthGuard } from "@/components/auth/auth-guard";

import { route as authRoute } from "./auth";
import { route as dashboardRoute } from "./dashboard";

export const routes: RouteObject[] = [
	authRoute,
	dashboardRoute,
	{
		path: "*",
		element: (
			<AuthGuard>
				<NotFoundPage />
			</AuthGuard>
		),
	},
];
